import React from 'react'

import LandingManagerContainer from '../components/landing-manager/LandingManagerContainer'

const LandingManagerScreen = props => <LandingManagerContainer {...props} />

export default LandingManagerScreen
